<template>
  <div>
    <NuxtPage />
  </div>
</template>

<style>
html {
  scroll-behavior: smooth;
}
</style>

<style>
@tailwind base;
@tailwind components;
@tailwind utilities;

html {
  font-family: 'Inter', sans-serif;
}

body {
  font-family: 'Inter', sans-serif;
}

* {
  font-family: 'Inter', sans-serif;
}
</style>
